var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',[_vm._v("Logging out...")])
}
var staticRenderFns = []

export { render, staticRenderFns }